import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// import createPersistedState from 'vuex-persistedstate'

import app from './modules/app'
import user from './modules/user'
import settings from './modules/settings'
import train from './modules/train'
import therapy from '@therapy/store/index'

import getters from './getters'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: '_STATE_' + process.env.VUE_APP_CUR_BRAND,
  storage: window.localStorage,
  modules: ['settings', 'app'],
})

/**
 * 劫持 commit dispatch
 * 发送 postMessage
 */
// const postStore = store => {
//   store.subscribe((mutation, state, origin) => {
//     if (!window.tdFrame) {
//       return
//     }
//     if (mutation.type.includes('therapy')) {
//       window.tdFrame.postMessage(
//         {
//           type: mutation.type,
//           payload: mutation.payload,
//           commit: true,
//         },
//         '*'
//       )
//     }
//   })
//   store.subscribeAction((action, state, origin) => {
//     if (!window.tdFrame) {
//       return
//     }
//     window.tdFrame.postMessage(
//       {
//         type: action.type,
//         // payload: action.payload,
//         dispatch: true,
//       },
//       '*'
//     )
//   })
// }

export default new Vuex.Store({
  strict: !process.env.NODE_ENV === 'production',
  modules: {
    app,
    user,
    settings,
    train,
    therapy,
  },
  getters,
  plugins: [
    // postStore,
    vuexLocal.plugin,
  ],
})
